import { Pencil } from "lucide-react";
import { money } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { ItemImageButton, ItemThumb } from "@/components/ItemImage";

export const Margin = ({ it }) => {
  if (!it.cost_price || !it.unit_price) return <span className="text-slate-400">—</span>;
  const pct = ((it.unit_price - it.cost_price) / it.unit_price) * 100;
  return <span className={`num font-semibold ${pct < 0 ? "text-red-600" : pct < 20 ? "text-amber-600" : "text-emerald-700"}`}>{pct.toFixed(1)}%</span>;
};

const Card = ({ it, admin, onEdit, onUploaded }) => (
  <div className="group relative flex flex-col overflow-hidden rounded-lg border border-slate-200 bg-white transition-shadow hover:shadow-md fade-up" data-testid={`item-card-${it.sku}`}>
    <span className="num absolute left-2 top-2 z-10 rounded bg-[#1BA3E0] px-2 py-0.5 text-sm font-semibold text-white">{money(it.unit_price)}</span>
    {!it.has_gst && <span className="absolute right-2 top-2 z-10 rounded bg-amber-100 px-1.5 py-0.5 text-[10px] font-bold uppercase text-amber-800">GST Free</span>}
    <div className="aspect-square bg-white p-3"><ItemThumb item={it} className="h-full w-full" /></div>
    <div className="flex-1 px-3 pb-3">
      <div className="text-sm font-semibold leading-snug text-[#0B1523]">{it.name}</div>
      {admin && <div className="mt-1 text-xs text-slate-500" data-testid={`item-card-cost-${it.sku}`}>Cost <span className="num">{money(it.cost_price)}</span> · <Margin it={it} /></div>}
      <div className="num mt-0.5 text-xs text-slate-500">{it.sku}{it.unit && ` · ${it.unit}`}</div>
    </div>
    <div className={`px-3 py-1.5 text-xs font-semibold ${it.stock > 0 ? "bg-slate-100 text-slate-700" : "bg-red-50 text-red-700"}`} data-testid={`item-stock-${it.sku}`}>
      {it.stock} in stock
    </div>
    {admin && (
      <div className="absolute right-2 top-9 z-10 flex flex-col gap-1 opacity-0 transition-opacity group-hover:opacity-100">
        <ItemImageButton item={it} onUploaded={onUploaded} />
        <Button size="sm" variant="secondary" onClick={() => onEdit(it)} data-testid={`item-card-edit-${it.sku}`}><Pencil className="h-4 w-4" /></Button>
      </div>
    )}
  </div>
);

export const ItemsGrid = ({ rows, admin, onEdit, onUploaded }) => {
  const groups = {};
  rows.forEach((it) => (groups[it.category || "Other"] ||= []).push(it));
  if (!rows.length) return <div className="px-4 py-16 text-center text-slate-500" data-testid="items-empty">No items found.</div>;
  return (
    <div data-testid="items-grid">
      {Object.keys(groups).sort().map((cat) => (
        <section key={cat}>
          <div className="border-y border-slate-200 bg-slate-50 px-4 py-2 font-semibold text-[#01195D]">{cat}</div>
          <div className="grid grid-cols-2 gap-4 p-4 sm:grid-cols-3 lg:grid-cols-5">
            {groups[cat].map((it) => <Card key={it.id} it={it} admin={admin} onEdit={onEdit} onUploaded={onUploaded} />)}
          </div>
        </section>
      ))}
    </div>
  );
};
